module.exports = __webpack_public_path__ + "static/media/summer.33514809.png";